import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasRetiro() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Retiro, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas cuidadosas cerca del Parque del Retiro</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/carousel-3.webp"
            alt="Mudanzas en Retiro"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          El distrito de <strong>Retiro</strong> es uno de los más demandados de Madrid para vivir. Su proximidad al Parque del Retiro, sus amplios pisos y su excelente comunicación lo convierten en una zona de alta rotación de viviendas. En Britosa Mudanzas realizamos mudanzas en Retiro con la rapidez y el cuidado que este barrio merece.
        </p>

        <h2>Mudanzas en el corazón verde de Madrid</h2>
        <p>
          Mudarse cerca del Retiro tiene sus ventajas y sus desafíos. Las calles anchas facilitan la carga y descarga, pero los edificios históricos y las fincas regias requieren un trato especial. Nuestro equipo conoce las particularidades de cada tipo de edificio en la zona.
        </p>
        <ul>
          <li>Mudanzas a pisos señoriales con techos altos y puertas dobles.</li>
          <li>Traslados a áticos con terraza y mobiliario de exterior.</li>
          <li>Mudanzas de oficinas y consultas médicas en la zona.</li>
          <li>Embalaje especializado para obras de arte y antigüedades.</li>
        </ul>

        <h2>Barrios del Retiro que cubrimos</h2>
        <p>
          Pacífico, Adelfas, Estrella, Ibiza, Jerónimos, Niño Jesús y todas las zonas del distrito de Retiro.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Mudanza en Retiro sin estrés</h3>
          <p style={{ marginBottom: "1rem" }}>
            Solicita tu presupuesto gratis. Conocemos cada rincón del distrito.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Retiro",
          "description": "Mudanzas profesionales en Retiro, Madrid. Cerca del Parque del Retiro.",
          "url": "https://mudanzasbritosa.com/mudanzas-retiro",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Retiro, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.4143,
            "longitude": -3.6825
          },
          "areaServed": {
            "@type": "City",
            "name": "Retiro"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
